import { useTranslations } from 'next-intl';

export type MessageType =
  | 'already-subscribed'
  | 'invalid-email'
  | 'required'
  | 'fetch-success'
  | 'fetch-error'
  | null;

interface MessageComponentProps {
  message: string;
}

const ErrorMessage = ({ message }: MessageComponentProps) => {
  return <span className="text-red-600">{message}</span>;
};

const SuccessMessage = ({ message }: MessageComponentProps) => {
  return <span>{message}</span>;
};

const MESSAGE_COMPONENTS: Record<
  NonNullable<MessageType>,
  React.FC<MessageComponentProps>
> = {
  'fetch-success': SuccessMessage,
  'fetch-error': ErrorMessage,
  'already-subscribed': ErrorMessage,
  'invalid-email': ErrorMessage,
  required: ErrorMessage,
};

const SubscribeMessage = ({ messageType }: { messageType: MessageType }) => {
  const t = useTranslations('Footer.subscribe.message');
  if (!messageType) return null;

  const MessageComponent = MESSAGE_COMPONENTS[messageType];
  return (
    <div
      id="footer-subscribe-message"
      role="alert"
      className="helper_text px-[10px] py-[15px] text-xs font-medium "
    >
      <MessageComponent message={t(messageType)} />
    </div>
  );
};

export default SubscribeMessage;
